module.exports = __webpack_public_path__ + "static/media/cc.288f78a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cc.svg
// module id = 80
// module chunks = 0